import { observer } from "mobx-react-lite"
import { useContext, useState } from "react";
import { Context } from "..";
import MultiSwitcherStage from "../components/ui/MultiSwitcherStage";
import { ReactComponent as Faq } from "../images/icons/faq.svg";
import "../styles/auth.css";
import bg from "../images/bg.jpg";
import { ReactComponent as Logo } from "../images/logo1.svg";
import useNotification from "../hooks/useNotification";

const Auth = () => {
    const { warning, error } = useNotification();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const { store } = useContext(Context);
    const [isAuth, setIsAuth] = useState(true);
    // const [showPassword, setShowPassword] = useState(false);
    
    const auth = async (event) => {
        event.preventDefault();
        if (!email || email.replace(" ", "") == "") {
            warning("Email не обнаружен.");
            return;
        }
        if (!password || password.replace(" ", "") == "") {
            warning("Пароль не может быть пустым.");
            return;
        }
        if (!isAuth && (!name || name.replace(" ", "") == "")) {
            warning("Имя не может быть пустым.");
            return;
        } 

        try {
            if (isAuth) {
                let result = await store.login(email, password);
                if (result.error === false) window.location.replace('/calc');
                else error("Ошибка авторизации. Неверный email или пароль", { autoClose: false });
            } else {
                // if (password !== confirmPassword) return;
                let result = await store.registration(email, name, surname, password);
                if (result.error === false) window.location.replace('/calc');
                else error("Ошибка регистрации. Получены некорректные данные", { autoClose: false });
            }
        } catch (err) {
            console.log("auth error:", err);
            error("Внутренняя ошибка сервера, повторите попытку позже или обратитесь в службу поддержки", { autoClose: false });
        }
    }

    return (
        <div className="loginForm">
            <div className="formBlock">
                <div className="form">
                    <div className="logo"><Logo/></div>
                    <div className="formContent">
                        <MultiSwitcherStage
                            values={[{ name: "Войти" }, { name: "Зарегистрироваться" }]}
                            selectValue={(itemIndex) => setIsAuth(itemIndex == 0)}
                            forceSelected={isAuth ? 0 : 1}
                            defaultValue={isAuth ? 0 : 1}
                        />
                        {isAuth 
                            ? <ul>
                                <li>
                                    <input 
                                        type="email" 
                                        placeholder="Почта" 
                                        value={email} 
                                        onChange={(e) => setEmail(e.target.value)}
                                        autoComplete="username"
                                    />
                                </li>
                                <li>
                                    <input 
                                        type="password" 
                                        placeholder="Пароль" 
                                        value={password} 
                                        onChange={(e) => setPassword(e.target.value)}
                                        autoComplete="current-password"
                                    />
                                </li>
                            </ul>
                            : <ul>
                                <li>
                                    <input 
                                        type="text" 
                                        placeholder="Имя" 
                                        value={name} 
                                        onChange={(e) => setName(e.target.value)}
                                        autoComplete="off" 
                                    />
                                </li>
                                <li>
                                    <input 
                                        type="text" 
                                        placeholder="Фамилия" 
                                        value={surname} 
                                        onChange={(e) => setSurname(e.target.value)}
                                        autoComplete="off" 
                                    />
                                </li>
                                <li>
                                    <input 
                                        type="email" 
                                        placeholder="Почта" 
                                        value={email} 
                                        onChange={(e) => setEmail(e.target.value)}
                                        autoComplete="username"
                                    />
                                </li>
                                <li>
                                    <input 
                                        type="password" 
                                        placeholder="Пароль" 
                                        value={password} 
                                        onChange={(e) => setPassword(e.target.value)}
                                        autoComplete="new-password"
                                    />
                                </li>
                            </ul>
                        }
                        <button className="activeButton" onClick={auth}>{isAuth ? "Войти" : "Зарегистрироваться"}</button>
                        {isAuth 
                            ? <a href="" className="grey">Забыли пароль?</a>
                            : <p>Уже есть аккаунт? <a onClick={() => setIsAuth(true)}>Войдите</a></p>
                        }
                    </div>
                </div>
                <div className="fqa"><Faq/> Есть вопросы? Задайте их нам</div>
            </div>
            
            <div className="bigText">
                <div className="text">
                    <div>Цифры не лгут -</div>
                    <div>считайте с <br />уверенносью</div>
                </div>
            </div>
            <div className="bg"><div className="darker"></div><img src={bg}/></div>
        </div>
    )
}

export default observer(Auth);
